export default "__VITE_ASSET__BrBpzwTN__"